// extracted by mini-css-extract-plugin
export var burgerMenu = "header-module--burger-menu--4bbbb";
export var burgerMenuOpen = "header-module--burger-menu-open--3fc8d";
export var burgerMenuTitle = "header-module--burger-menu-title--97cfe";
export var header = "header-module--header--f1378";
export var headerBurgerMenuOpen = "header-module--header-burger-menu-open--aff90";
export var headerSocial = "header-module--header-social--b32b2";
export var logoSite = "header-module--logo-site--cd6b5";
export var logoSiteImg = "header-module--logo-site-img--e8f1b";
export var mainNav = "header-module--main-nav--3036c";
export var navItem = "header-module--nav-item--3027a";
export var navItemName = "header-module--nav-item-name--d9666";
export var navList = "header-module--nav-list--2ee07";
export var subNav = "header-module--sub-nav--dff96";
export var subNavContainer = "header-module--sub-nav-container--9ab9a";
export var subNavItemTitle = "header-module--sub-nav-item-title--3a887";
export var subNavName = "header-module--sub-nav-name--7798d";